//export const EV_ADMIN_IDENTITY_READY = 'EV_ADMIN_IDENTITY_READY'
export const EV_AUTHORIZE_ERROR = 'EV_AUTHORIZE_ERROR'
export const EV_CONTENT_UPDATE_LANGUAGE = 'EV_CONTENT_UPDATE_LANGUAGE'
